riot.tag2('bbc-notifications', '<bbc-notifications-bell alert="{this.alert}" state="{this.state}"></bbc-notifications-bell> <bbc-notifications-drawer name="drawer" class="" component-app="{this}" state="{this.state}" onboarding="{this.onboarding}" idcta-data="{this.idctaData}" notifications="{this.notifications}" reached-end="{this.reachedEnd}" loading-more="{this.loadingMore}" error="{this.error}" has-setup="{this.hasSetup}" subscription-count="{this.subscriptionCount}"></bbc-notifications-drawer>', '', '', function(opts) {
'use strict';

var _this = this;

require('whatwg-fetch');
var config = require('../config');
var notificationsAnalytics = require('../analytics');
var NotificationsModelClass = require('../models/NotificationsModel').NotificationsModel;
var userPreferencesModel = require('../models/UserPreferences');

var drawerName = 'notifications';

this.state = opts.mainApp.idcta.hasCookie() ? 'signed-in' : 'signed-out';
this.alert = false;
this.onboarding = false;
this.notifications = [];
this.reachedEnd = false;
this.loadingMore = false;
this.error = {};
this.hasSetup = false;
this.ptrt = encodeURIComponent(window.location.href.replace(window.location.hash, ''));

this.fetchIdctaData = function () {
    return new Promise(function (resolve, reject) {
        // eslint-disable-line

        var userDetails = opts.mainApp.idcta.getUserDetailsFromCookie() || {};
        console.log('IDCTA User details', userDetails);
        if (_this.state === 'signed-in' && userDetails.ab !== 'u13') {
            console.log('IDCTA User details skipping init');

            _this.update({ idctaData: {} });
            return resolve();
        }

        fetch(config.env.preferencesUrls.idcta + '?buttonColour=white&policy=notification&ptrt=' + _this.ptrt, { //eslint-disable-line
            credentials: 'include'
        }).then(function (res) {
            return res.json();
        }).then(function (data) {
            var htmlJs = void 0;

            var escapedHtml = data.html.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, function (x) {
                var script = x.substring(x.indexOf('>') + 1);
                script = script.slice(0, script.indexOf('</script'));
                htmlJs = script;
                return '';
            });

            data.html = escapedHtml;
            if (htmlJs) {
                data.htmlJs = encodeURI(htmlJs);
            }

            console.log('IDCTA data', data);
            _this.update({ idctaData: data });
        }).catch(function (err) {
            return reject(err);
        }).then(function () {
            return resolve();
        });
    });
};

this.isUserOnBoarded = function () {
    var userDetails = opts.mainApp.idcta.getUserDetailsFromCookie();
    console.log('User details', userDetails);
    if (userDetails && userDetails.ab === 'u13' && _this.idctaData && !_this.idctaData.policyCheck) {
        return true;
    }

    var preferencesData = userPreferencesModel.get();
    if (!preferencesData) {
        return null;
    }

    console.log('Preferences model', preferencesData);
    var userPreferences = preferencesData.preferences;

    return userPreferences !== null && typeof userPreferences.hasOnboarded !== 'undefined' ? userPreferences.hasOnboarded : false;
};

this.setOnboarding = function (setting) {
    console.log('Setting onboarding', setting);

    if (!setting) {
        _this.update({ alert: false });
        _this.initModel();
    }

    _this.update({ onboarding: setting });
};

this.drawerStateChangedCallback = function (newState) {
    console.log('Drawer is now', newState);
    _this.update({ alert: false });

    if (newState === 'hidden') {
        if (_this.notificationsModel) {
            var markedSeen = _this.notificationsModel.markAllAsSeen();
            _this.update({
                notifications: markedSeen
            });
        }
    } else {
        _this.logNewNotifications();
        if (document.activeElement && document.activeElement.classList && document.activeElement.classList.contains('js-notification-link')) {
            document.querySelector('.notifications__settings--js').focus();
        }
    }

    // User is signed-in
    if (_this.state === 'signed-in') {
        if (typeof app !== 'undefined') {
            // return app.drawerStateChanged(newState);
            // TODO replace with an event for the main view to deal with

            return;
        }

        if (_this.isUserOnBoarded() === true) {
            // update the users preferences
            userPreferencesModel.updateRead(true);
        } else if (!_this.onboarding && !_this.errorState) {
            // Load the on-boarding drawer if they haven't yet onboarded
            _this.setOnboarding(true);
        }
    } else if (newState === 'hidden') {
        // User is signed-out
        notificationsAnalytics.log('close-pane', 'notifications-icon');
    } else {
        // Analytics event (upsell when user is signed-out)
        notificationsAnalytics.log('upsell', 'notifications-icon');
    }

    _this.trigger('drawerStateChanged', newState);
};

this.fetchPreferences = function () {
    console.log('Refetching preferences from interval');
    userPreferencesModel.fetch().catch(function (err) {
        notificationsAnalytics.log('error-fetch-preferences', 'notifications-error');
        _this.setError('main', 'hub');
        throw err;
    }).then(function () {
        _this.removeError('main');
    });
};

this.fetchNotifications = function (fetchNext) {
    if (fetchNext) {
        _this.update({ loadingMore: true });
    }

    var prevNotificationsLength = _this.notifications.length;

    return _this.notificationsModel.fetch(fetchNext).catch(function (err) {
        notificationsAnalytics.log('error-fetch-notifications', 'notifications-error');
        _this.setError('main', 'hub');
        throw err;
    }).then(function (response) {
        if (!response) {
            return;
        }

        var notifications = response.notifications;
        var reachedEnd = response.reachedEnd;

        console.log('Notifications', notifications.length, notifications, reachedEnd ? 'ENDED' : '...');

        _this.notifications = notifications;
        if (reachedEnd) {
            _this.reachedEnd = reachedEnd;
        }
        _this.loadingMore = false;

        var hasNew = false;
        notifications.forEach(function (i) {
            if (i.status === 'new') {
                hasNew = true;
            }
        });

        console.warn('Has new?', hasNew);
        if (hasNew) {
            _this.logNewNotifications();

            if (notifications.length > prevNotificationsLength) {
                _this.alert = true;
            }
        }

        _this.removeError('main');

        _this.update();
    });
};

this.setError = function (type, val) {
    console.error('Displaying error', type, val);
    _this.logError();
    _this.error[type] = val;
    _this.update();
};

this.logError = function () {
    var errorType = 'error1-retrieve-fail';
    if (_this.hasSetup) {
        errorType = 'error2-update-fail';
    }
    notificationsAnalytics.log(errorType, 'notifications-error');
};

this.removeError = function (type) {
    delete _this.error[type];
    _this.update();
};

this.resetNotifications = function () {
    _this.update({ notifications: [], reachedEnd: false });
    _this.notificationsModel.reset();
    _this.fetchNotifications();
};

this.initModel = function () {
    console.log('inside init model');
    if (!_this.notificationsModel && !_this.error.main) {
        console.log('Instantiating model class');
        _this.notificationsModel = new NotificationsModelClass();
        console.log('Fetching notifications');
        _this.fetchNotifications();
        window.setInterval(_this.fetchNotifications, config.env.notificationsPollingInterval);
        window.setInterval(_this.fetchPreferences, config.env.preferencesPollingInterval);
    }
};

this.updateSubscriptionCount = function (reset) {
    console.log('Updating subscription count...', reset);

    _this.update({
        subscriptionCount: reset || userPreferencesModel.countActiveSubscriptions()
    });
};

this.setup = function () {
    _this.fetchIdctaData().catch(function (err) {
        notificationsAnalytics.log('error-setup-fetch-idcta', 'notifications-error');
        _this.setError('main', 'hub');
        throw err;
    }).then(function () {
        if (_this.state === 'signed-in') {
            userPreferencesModel.fetch().catch(function (err) {
                notificationsAnalytics.log('error-setup-fetch-preferences', 'notifications-error'); // eslint-disable-line
                _this.setError('main', 'hub');
                throw err;
            }).then(function () {
                _this.subscriptionCount = userPreferencesModel.countActiveSubscriptions();

                if (_this.isUserOnBoarded() === false) {
                    console.log('Not onboarded, ring the bell');
                    _this.update({ alert: true });
                } else {
                    _this.initModel();
                }

                console.log('Completed setup');
                _this.removeError('main');
                _this.update({ hasSetup: true });
                _this.trigger('finishedSetup');
            });
        }
    });

    // Create drawer holder
    var drawerContent = document.createElement('div');
    drawerContent.className = 'orb-panel';
    drawerContent.appendChild(_this.drawer);

    // Move drawer into Orbit
    opts.orb.addDrawer(drawerName, document.querySelector('.js-notification-link'), drawerContent, _this.drawerStateChangedCallback);

    // Set notif icon. Needed for onboarding file.
    opts.mainApp.setNotificationIcon();
};

var alreadyLoggedNotifications = [];

this.logNewNotifications = function () {
    if (opts.mainApp.getDrawerState() === 'shown') {
        console.log('Checking for new notifications to log');
        _this.notifications.forEach(function (item) {
            if (item.status === 'new' && !(alreadyLoggedNotifications.indexOf(item.id) !== -1)) {
                notificationsAnalytics.log('seen', 'notifications-item', {
                    notifications_id: item.id,
                    notifications_state: 'blueDot',
                    notifications_priority: (item.priority || 'normal').toLowerCase(),
                    notifications_product: item.product.toLowerCase(),
                    notifications_type: item.type.toLowerCase(),
                    notifications_title: item.notification.title,
                    topic_name: notificationsAnalytics.serialiseTopic(item.topic)
                });
                alreadyLoggedNotifications.push(item.id);
            }
        });
    }
};

this.on('mount', this.setup);
this.on('updated', function () {
    console.log('Notifications component updated!', drawerName);
    opts.mainApp.updateWrapperMaxHeight();
});
});



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/components/bbc-notifications.tag
 ** module id = 28
 ** module chunks = 0
 **/